import React from 'react';

const CostDetailFieldSet = (props) => {
    if (props.hidden)
        return '';

    return (
        <div>
            <div className="input-group rounded-0">
                <div className="input-group-prepend" style={{width: 15 + '%'}}>
                    <span className="input-group-text bg-white border-0">FY{props.fy}</span>
                </div>
                <div className="input-group-prepend rounded-0">
                    <span className="input-group-text">Proceeds</span>
                </div>
                <input
                    className="form-control rounded-0 text-right"
                    type="text"
                    name={"cost-" + props.fy}
                    value={props.cost ? props.cost : ''}
                    disabled={props.disabled}
                    fy={props.fy}
                    onChange={props.onInputChange} 
                    autoComplete="off" />
                <div className="input-group-prepend rounded-0">
                    <span className="input-group-text">Equity</span>
                </div>
                <input
                    className="form-control rounded-0 text-right"
                    type="text"
                    name={"equity-" + props.fy}
                    value={props.equity ? props.equity : ''}
                    disabled={props.disabled}
                    fy={props.fy}
                    onChange={props.onEquityInputChange} 
                    autoComplete="off" />
            </div>
        </div>
    );
}

export default CostDetailFieldSet;
